module.exports = __webpack_public_path__ + "img/defaultGeoPic.eebb137b.png";